import React from 'react';
import {Typography} from '@mui/material';
import {themmeColor} from 'src/constants/constants';
import {
  MessageAuthorType,
  MessageSubType,
} from 'src/store/queries/queries.reducer';
import Box from 'src/DesignSystem/Box/Box';
import TickIcon from 'src/icons/TickIcon';
import WarningIcon from 'src/icons/WarningIcon';
import {MessageProps} from './Message';
import MessageWrapper from './MessageWrapper';

export const HistoryMessage = ({message, query}: MessageProps) => {
  const isFromUser = message.authorType === MessageAuthorType.END_USER;

  const isResolvedType = message.messageSubType === MessageSubType.RESOLVED;
  return (
    <MessageWrapper query={query} message={message}>
      <Box
        style={{
          display: 'flex',
          paddingBlock: 8,
          paddingInline: 16,
          backgroundColor: isResolvedType
            ? themmeColor.deductionGreen
            : themmeColor.cpaCenterV2Bg,
          alignItems: 'center',
        }}>
        {
          <div style={{marginRight: 8, display: 'flex'}}>
            {isResolvedType ? <TickIcon /> : <WarningIcon />}
          </div>
        }
        <Typography
          style={{
            fontWeight: 600,
            fontSize: 11,
            textTransform: 'uppercase',
          }}>
          Question {isResolvedType ? 'resolved' : 're-opened'} by{' '}
          {isFromUser ? message.authorName : `CPA (${message.authorName})`}
        </Typography>
      </Box>
    </MessageWrapper>
  );
};
